import { SocietyCorporateId } from 'types/Society';

const GA_MEASUREMENT_ID = 'G-LWNDHYBY2N';

const clearGACookies = () => {
  if (typeof document === 'undefined') return;
  document.cookie =
    '_ga_LWNDHYBY2N=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure; samesite=strict';
  document.cookie =
    '_ga=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure; samesite=strict';
};

/**
 * Inicializa Google Analytics (gtag) solo cuando REACT_APP_UI_CORPORATE_ID no es "axa".
 * Para el tenant AXA no se cargan las cookies ni el script de GA.
 */
export const initGoogleAnalytics = () => {
  if (typeof window === 'undefined') return;
  if (process.env.REACT_APP_UI_CORPORATE_ID === SocietyCorporateId.AXA) {
    return;
  }

  clearGACookies();

  window.dataLayer = window.dataLayer || [];
  function gtag(...args) {
    window.dataLayer.push(args);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    cookie_flags: 'secure;samesite=strict',
    cookie_domain: 'auto',
    cookie_expires: 63072000,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};
